var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5"},React.createElement("path",{"d":"M9 16V2M2 9l7-7 7 7"})));
}

ArrowUp.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
